<template>
  <transition name="slide-fade"> 
    <div v-show='modelVisable' class="models">
      <mt-header title="地区选择">
          <router-link to="" slot="left">
            <mt-button icon="back" @click="hideModel" ></mt-button>
          </router-link>
        </mt-header>
        <div class="content">
          <div class="items">
            <!-- // 等级 ，0 是省，1 是市，2 是区或者分公司-->
            <!-- 省账号进来可以选 省 市 区 -->
            <div v-if='userInfo.level == 0'>
              <div class="items-header">省份</div>
              <div class="items-body">
                <div @click="changeProvince()" class="items-body-item items-body-item-active">全省</div>
                <div class="clearfix"></div>
              </div>
              <div class="bg-height"></div>
            </div>
            <!-- 省账号进来可以选 市 区 -->
            <div v-if='userInfo.level == 0'>
              <div >
                <div class="items-header">地市</div>
                <div class="items-body items-body-2">
                  <div v-for="(c,i) in this.areaDatas.children" :key='c.id' @click="changeCity(i, c.id,c.name)" :class="{'items-body-item-active':c.id == selectCityId}" class="items-body-item">{{c.name | valueFromt}}</div>
                  <div class="clearfix"></div>
                </div>
                <div class="bg-height"></div>
              </div>
              <div >
                <div class="items-header">区县</div>
                <div class="items-body items-body-2">
                  <div v-for="(c,i) in areaList" :key='c.id' @click="changeArea(i, c.id,c.name)" :class="{'items-body-item-active':c.id == selectAreaId}" class="items-body-item">{{c.name | valueFromt}}</div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
            <!-- 市账号进来可以选 区 ，还有 区 账号进不来 -->
            <div v-if='userInfo.level == 1'>
              <div >
                <div class="items-header">地市</div>
                <div class="items-body items-body-2">
                  <div @click="changeAreaParent" class="items-body-item items-body-item-active">{{ userInfo.area | valueFromt}}</div>
                  <div class="clearfix"></div>
                </div>
                <div class="bg-height"></div>
              </div>
              <div class="items-header">区县</div>
              <div class="items-body items-body-2">
                <div v-for="(c,i) in areaList" :key='c.id' @click="changeArea(i, c.id,c.name)" :class="{'items-body-item-active':c.id == selectAreaId}" class="items-body-item">{{c.name | valueFromt}}</div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div @click="reset" class="left">重置</div>
          <div @click="submit" class="right">确定</div>
        </div>
    </div>
  </transition>
</template>
<script>
export default {
  components: {},
  props: {
    // 是否展示 model
    showModel: {
      type: Boolean,
      default: false
    },
    // 传过来的所在地区的 id
    defaultId: {
      type: [Number, String],
      default: 0
    }
  },
  filters: {
    // 去掉数值前面的字母
    valueFromt: function(value) {
      if (!value) return "";
      if (value.includes("_")) {
        return value.slice(2);
      } else {
        return value;
      }
    }
  },
  data() {
    return {
      modelVisable: false,
      cityList: [], // 市的 list
      areaList: [], //区的 list
      isSelectArea: false, //是否选择了区
      selectCityId: "", //选择了市的id
      selectAreaId: "", //选择了区的id
      selectAreaName: "全省" //选择了的名字
    };
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.userInfo;
    },
    // 用户所在地区及下面的地区的信息
    areaDatas() {
      return this.$store.state.areaDatas;
    }
  },
  watch: {
    showModel(value) {
      this.modelVisable = value;
    },
    userInfo() {
      this.getAreasData();
    }
  },
  methods: {
    // 提交
    submit() {
      let obj = {
        isSelectArea: this.isSelectArea,
        selectCityId: this.selectCityId,
        selectAreaId: this.selectAreaId,
        selectAreaName: this.selectAreaName
      };
      this.$emit("ok", obj);
      this.modelVisable = false;
      this.$emit("hide", 1);
    },
    // 重置
    reset() {
      this.selectCityId = "";
      this.selectAreaId = "";
    },
    // 关闭 model
    hideModel(type) {
      this.modelVisable = false;
      this.$emit("hide", 1);
    },
    // 选择城市
    changeCity(index, id, name) {
      this.isSelectArea = false;
      this.areaList = this.areaDatas.children[index].children;
      this.selectCityId = id;
      this.selectAreaId = "";
      this.selectAreaName = name;
    },
    // 选择 区 的父级
    changeAreaParent(){
      this.isSelectArea = false;
      this.selectCityId = this.userInfo.aid;
      this.selectAreaId = "";
      this.selectAreaName = this.userInfo.area;
    },
    // 选择地区
    changeArea(index, id, name) {
      // this.selectCityId = "";
      this.isSelectArea = true;
      this.selectAreaId = id;
      this.selectAreaName = name;
    },
    // 点击省份
    changeProvince() {
      this.isSelectArea = false;
      this.areaList = [];
      this.selectCityId = "";
      this.selectAreaId = "";
      this.selectAreaName = "全省";
    },
    // 根据用户身份获取地区数据
    getAreasData() {
      this.$store
        .dispatch("EGT_USER_AREAS")
        .then(res => {
          if (res.data.code === 200) {
            if (this.userInfo.level == 1) {
              this.areaList = res.data.data.children;
            } else {
              this.cityList = res.data.data.children;
            }
          } else {
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.font-family-fn(@family) {
  font-family: @family;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.15s ease;
}
.slide-fade-leave-active {
  transition: all 0.15s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.models {
  color: #2f2f2f;
  width: 100%;
  height: auto;
  z-index: 99999999;
  background: #fff;
  padding-bottom: 1rem;
  position: fixed;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  .bg-height {
    height: 0.2rem;
    width: 100%;
    background-color: #f4f4f4;
  }
  .mint-header .mint-button {
    padding-right: 0.3rem;
  }
  .mint-popup-right {
    width: 100%;
    min-height: 100%;
    border-radius: 0;
  }
  .content {
    overflow: scroll;
    font-size: 0.3rem;
    min-height: 13rem;
    .items {
      // padding: 0.2rem 0;
      .items-header {
        padding: 0 0.3rem;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: left;
      }
      .items-body {
        margin-bottom: 0.2rem;
        padding: 0 0.3rem;
        // min-width: 4rem;
        .items-body-item {
          font-size: 0.26rem;
          text-align: center;
          width: 1.92rem;
          margin-top: 0.2rem;
          float: left;
          padding: 0.1rem 0.1rem;
          border: 0.02rem solid #eee;
          margin-right: 0.2rem;
        }
        .items-body-item:nth-child(3n) {
          margin-right: 0rem;
        }
        .items-body-item-active {
          background-color: #f4f4f4;
        }
      }
      .items-body {
        min-width: 4rem;
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    font-size: 0.3rem;
    height: 1rem;
    width: 100%;
    background: 0.02rem solid #eee;
    .left,
    .right {
      float: left;
      width: 50%;
      text-align: center;
      line-height: 1rem;
      background-color: #fff;
      border-top: 0.02rem solid #eee;
    }
    .right {
      color: #fff;
      background-color: #0384df;
      border-top: 0.02rem solid #0384df;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app/add/modelArea.vue